// The four rules a person confirms before acting in the organization's name. Two screens show
// them: the open-fund request's pre-submit popup, and the portal's entry gate, which every
// coordinator passes once (HAT-1256) - hence this shared home rather than a page folder.
//
// The server holds its own copy, in WebApi/Models/Constants/FundRules.cs, because it prints them
// onto both the request PDF and the signed acceptance copy. Keep the two in sync.
//
// HAT-1258: the reporter reviewed a shortened set and kept the original text everywhere except
// 'consideration', which he asked to replace with the shorter sentence below - the one that also
// rules out segulot and yeshuot.
export type FundRuleId = 'consideration' | 'telemarketing' | 'compliance' | 'breach';

export interface FundRuleDeclaration {
  /** Stable key the dialog uses to pick the rule's icon. */
  id: FundRuleId;
  title: string;
  text: string;
}

export const FUND_RULES_DECLARATIONS: FundRuleDeclaration[] = [
  {
    id: 'consideration',
    title: 'אין תמורה בעד תרומה',
    text: 'לא הגרלה, מתנה, הטבה, סגולה, ישועה, מוצר או שירות. הכספים הם תרומה בלבד.',
  },
  {
    id: 'telemarketing',
    title: 'טלמרקטינג',
    text: 'מובהר כי לא ניתן להפעיל טלמרקטינג לגיוס כספים עבור הפרויקט.',
  },
  {
    id: 'compliance',
    title: 'עמידה בכללי הפרויקט',
    text: 'הריני מתחייב לעמוד בכל התנאים והכללים המפורטים בתנאי השימוש ובנהלי העמותה ובמסמכי ההצטרפות.',
  },
  {
    id: 'breach',
    title: 'אי-עמידה בכללים',
    text: 'ידוע לי כי במידה והפרויקט לא יעמוד בכללים, הפרויקט ייסגר לאלתר והכספים שגויסו ינותבו וינוהלו על פי שיקול דעתה הבלעדי של העמותה.',
  },
];

export const FUND_RULES_DIALOG_TITLE = 'אישור כללי הפרויקט';

export const FUND_RULES_DIALOG_SUBTITLE = 'לפני שליחת הבקשה, יש לקרוא את הכללים הבאים ולאשר אותם.';

export const FUND_RULES_CONFIRMATION_LABEL = 'קראתי, הבנתי ואני מאשר את הכללים המפורטים לעיל.';
